// import {combineReducers} from 'redux';
import projectReducer from './projectReducer';

const rootReducer = projectReducer

export default rootReducer;
